'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('utils/validation');

var validate = function validate(values) {
  var currentPassword = values.currentPassword,
      newPassword = values.newPassword,
      passwordConfirm = values.passwordConfirm;

  var t = require('i18n-universal').getT();
  var errors = {
    currentPassword: (0, _validation.required)(currentPassword),
    newPassword: (0, _validation.password)(newPassword),
    passwordConfirm: (0, _validation.password)(passwordConfirm)
  };

  if (newPassword && passwordConfirm && newPassword !== passwordConfirm) {
    errors.passwordConfirm = t('Password and confirmation do not match');
  }

  return errors;
};

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangePasswordForm/ChangePasswordFormValidation.js
// module id = 1963
// module chunks = 1